import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";
import "./index.css";
import "./styles/branding.css";

const baseUrl = import.meta.env.BASE_URL;
const trimmedBase = baseUrl.endsWith("/") ? baseUrl.slice(0, -1) : baseUrl;
const routerBase = trimmedBase || "/";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={routerBase}>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
